import React, { useState } from 'react'
import {
    Typography,
    Button,
    TextField
} from '@material-ui/core'

import PageTitle from '../../../global/PageTitle/PageTitle'
import ListTable from '../../../global/ListTable/ListTable'
import './Education.css'

const columns = [
    { key: 'school', label: 'School' },
    { key: 'degree', label: 'Degree' },
    { key: 'fieldOfStudy', label: 'Field of Study' },
    { key: 'startYear', label: 'Start Year' },
    { key: 'endYear', label: 'End Year' }
]

const emptyEntry = { school: '', degree: '', fieldOfStudy: '', startYear: '', endYear: '' }

// "Add" opens an add-education form; submitting it adds a row to the list (QA issue 9).
const Education = () => {
    const [entries, setEntries] = useState([])
    const [adding, setAdding] = useState(false)
    const [draft, setDraft] = useState(emptyEntry)

    const update = (field) => (e) => setDraft({ ...draft, [field]: e.target.value })
    const canSubmit = Boolean(draft.school && draft.degree)

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!canSubmit) return
        setEntries([...entries, { ...draft, id: entries.length + 1 }])
        setDraft(emptyEntry)
        setAdding(false)
    }

    const handleCancel = () => {
        setDraft(emptyEntry)
        setAdding(false)
    }

    return (
        <div>
        <PageTitle title="Education" back path="/career" />
        <div className="education-main">
            {entries.length === 0 && !adding && <Typography>none entered</Typography>}
            {entries.length > 0 && <ListTable columns={columns} rows={entries} emptyMessage="none entered" />}

            {adding && (
                <form className="education-form" onSubmit={handleSubmit} noValidate aria-label="Add Education" id="add-education-form">
                    <Typography variant="h6" className="education-form-title">Add Education</Typography>
                    <div className="education-field">
                        <Typography variant="caption" component="label" htmlFor="education-school" className="education-label">School</Typography>
                        <span className="mandatory">*</span>
                        <TextField id="education-school" name="school" required value={draft.school} onChange={update('school')} inputProps={{ 'aria-required': true }} className="education-input" />
                    </div>
                    <div className="education-field">
                        <Typography variant="caption" component="label" htmlFor="education-degree" className="education-label">Degree</Typography>
                        <span className="mandatory">*</span>
                        <TextField id="education-degree" name="degree" required value={draft.degree} onChange={update('degree')} inputProps={{ 'aria-required': true }} className="education-input" />
                    </div>
                    <div className="education-field">
                        <Typography variant="caption" component="label" htmlFor="education-field-of-study" className="education-label">Field of Study</Typography>
                        <TextField id="education-field-of-study" name="fieldOfStudy" value={draft.fieldOfStudy} onChange={update('fieldOfStudy')} className="education-input" />
                    </div>
                    <div className="education-field">
                        <Typography variant="caption" component="label" htmlFor="education-start-year" className="education-label">Start Year</Typography>
                        <TextField id="education-start-year" name="startYear" type="number" value={draft.startYear} onChange={update('startYear')} inputProps={{ min: 1900, max: 2100 }} className="education-input" />
                    </div>
                    <div className="education-field">
                        <Typography variant="caption" component="label" htmlFor="education-end-year" className="education-label">End Year</Typography>
                        <TextField id="education-end-year" name="endYear" type="number" value={draft.endYear} onChange={update('endYear')} inputProps={{ min: 1900, max: 2100 }} className="education-input" />
                    </div>
                    <div className="education-form-actions">
                        <Button type="submit" variant="contained" color="secondary" className="change-benefits-btn1" disabled={!canSubmit}>Save</Button>
                        <Button type="button" variant="contained" className="change-benefits-btn2" onClick={handleCancel}>Cancel</Button>
                    </div>
                </form>
            )}
        </div>
        <div className="change-benefits-btn-container" style={{position: "absolute", bottom: "0", display: "block"}}>
            <Button
                variant="contained"
                className="change-benefits-btn2"
                onClick={() => setAdding(true)}
                disabled={adding}
                aria-controls="add-education-form"
                aria-expanded={adding}
            >Add</Button>
            <Button
                variant="contained"
                className="change-benefits-btn2"
            >Upload My Experience</Button>
        </div>
        </div>
    )
}

export default Education
